import { useCallback, useState } from "react";
import AccountMpProvider from "@/core/data-provider/data-mp/account/account-mp-provider";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import useGetPlayer from "@/shared/hooks/useGetPlayer";

export default function useEnterToGame() {
  const tError = useErrorTranslation();
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState<string>("");
  const [isCompleted, setIsCompleted] = useState<null | boolean>(null);
  const { getPlayer } = useGetPlayer();

  const enterHandler = useCallback(async (characterId: string) => {
    try {
      setIsPending(true);
      setError("");

      const response = await AccountMpProvider.enter(characterId);

      if (response instanceof RpcMpProviderSuccessResponse) {
        setIsCompleted(true);
        await getPlayer();
      } else {
        setError(tError(response.message));
        setIsCompleted(false);
      }
    } catch ({ message }) {
      setError(tError(message));
      setIsCompleted(false);
    } finally {
      setIsPending(false);
    }
  }, []);

  return {
    enterHandler,
    isPending,
    isCompleted,
    error,
  };
}
